// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__RCGeM","newExpiryDate":"styles_newExpiryDate__1h7zi","footer":"styles_footer__Sep5n"};